<template>
	<div v-if="renderComponent && showFinalStandings">
		<h2 class="mb-4">{{ $t('competition.standings') }}</h2>
		<div>
			<table class="w-100 match-table">
				<thead>
					<tr>
						<th class="w-75px">{{ $t('competition.place') }}</th>
						<th>{{ $t('competition.team_name') }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(team, index) in standings" :key="team._id + '_' + index"
						:class="index === 0 ? 'gold' : index === 1 ? 'silver' : index === 2 ? 'bronze' : index === 3 ? 'copper' : ''">
						<td>
							<div class="d-flex align-items-center">
								{{ index + 1 }}
								<Icon v-if="index < 4" type="md-trophy" style="font-size: 20px; margin-left: 5px;"
									:class="index === 0 ? 'gold-medal' : index === 1 ? 'silver-medal' : index === 2 ? 'bronze-medal' : index === 3 ? 'copper-medal' : ''" />
							</div>
						</td>
						<td>
							<Tooltip :content="team.name" placement="top-start" class="w-100">
								<span class="text-overflow-style final-standing-clamt-text">
									{{ team.name }}
								</span>
							</Tooltip>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="mt-5">
			<Button
				v-if="competition.stages.findIndex(({ isCurrent }) => isCurrent) === competition.stages.length - 1 && !competition.isCompleted"
				type="info" @click="() => finishCompetition()" long size="large">
				<b>{{ $t('competition.finish') }}</b>
			</Button>
			<Button
				v-else-if="competition.stages.findIndex(({ isCurrent }) => isCurrent) !== competition.stages.length - 1 && !nextStageIsAvailable"
				type="info" @click="() => detectCurrentStage()" long size="large">
				<b>{{ $t('competition.next') }}</b>
			</Button>
		</div>
	</div>
</template>

<script>
import storeMixin from '../storeMixin';
import bracketsMixin from '../../../brackets/bracketsMixin';

export default {
	name: 'ShowFinalStandings',
	data() {
		return storeMixin;
	},
};
</script>

<style scoped>

.final-standing-clamt-text {
	width: 100%;
}

table {
	table-layout: fixed;
}

.w-75px {
	width: 75px;
	min-width: 75px;
}

.match-table {
	width: 100%;
}

.match-table.table-bordered tr td,
.match-table.table-bordered tr th {
	border-width: 1px !important;
}

.match-table.table-bordered td {
	border: none !important;
}

.tournament-stage .match-table td:hover {
	background: transparent !important;
}

.match-table td:hover {
	background: #e4e4e4;
}

.gold {
	background-color: #ffed9a;
}

.silver {
	background-color: #eeeeee;
}

.bronze {
	background-color: #f9e8c7;
}

.copper {
	background-color: #f9dec7;
}

.gold-medal {
	color: gold;
	filter: drop-shadow(0px 0px 0.1rem black);
}

.silver-medal {
	color: silver;
	filter: drop-shadow(0px 0px 0.1rem black);
}

.bronze-medal {
	color: burlywood;
	filter: drop-shadow(0px 0px 0.1rem black);
}

.copper-medal {
	color: rosybrown;
	filter: drop-shadow(0px 0px 0.1rem black);
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/schemes/formats/groups/ShowFinalStandings.vue